import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d07cbe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col p-1.5 md:p-1.5 flex-grow min-w-0" }
const _hoisted_2 = { class: "flex justify-start items-center gap-x-1 md:gap-x-1.5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-[15px] font-bold text-negative" }, "!", -1))
const _hoisted_4 = { class: "min-w-0 flex-grow" }
const _hoisted_5 = { class: "flex justify-start gap-x-1 md:gap-x-1.5 -mt-0.5 md:-mt-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[14px] md:w-[20px] h-[8px] md:h-[20px] shrink-0" }, null, -1))
const _hoisted_7 = { class: "mt-auto w-full" }
const _hoisted_8 = {
  key: 0,
  class: "w-full h-[14px] md:h-[18px] rounded-sm bg-white/30"
}
const _hoisted_9 = {
  key: 1,
  class: "flex justify-start gap-x-1 md:gap-x-1.5"
}
const _hoisted_10 = { class: "group-buttons w-full flex items-center justify-center gap-1 md:gap-2 flex-wrap" }
const _hoisted_11 = { class: "flex min-w-0 flex-grow flex-col gap-0.5 px-1.5 py-1" }
const _hoisted_12 = {
  class: "flex items-start justify-between gap-1",
  "data-testid": "station-row-avatar-row"
}
const _hoisted_13 = {
  key: 2,
  class: "h-[14px] w-6 shrink-0 rounded-sm bg-white/30",
  "data-testid": "station-row-alert-bar"
}
const _hoisted_14 = ["title", "aria-label"]
const _hoisted_15 = { class: "flex min-w-0 flex-grow items-center gap-2 p-1.5" }
const _hoisted_16 = { class: "flex min-w-0 flex-grow flex-col gap-0.5" }
const _hoisted_17 = ["title", "aria-label"]
const _hoisted_18 = {
  key: 1,
  class: "h-[14px] w-6 shrink-0 rounded-sm bg-white/30",
  "data-testid": "station-row-alert-bar"
}

import { computed } from 'vue'
import { getInitialsChar } from '@/utils/string'
import { nameInitials, stripHonorific } from '@/utils/stationDisplay'
import { resolveAvatarSrc } from '@/utils/avatar'
import ProtectedAvatar from '@/components/designSystem/AvatarUser/ProtectedAvatar.vue'
import PermanenceRecordIcon from '@/assets/icons/checks/permanence_registro.vue'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import {
  mdiTextBoxCheck,
  mdiAccountAlert,
  mdiClockAlertOutline,
  mdiClockCheckOutline,
  mdiClockEnd
} from '@mdi/js'
import {
  DoctorStationStatus,
  doctorStationStatusTranslate
} from '@/translations/doctor.station.status'
import {
  DoctorStationReminderStatus,
  ExceptionSummaryStatus
} from '@/Network/Types/Responses/StationResponses'
import type { PostStationCellStatus } from '@/Network/Types/Responses/StationResponses'
import StationRowIcons from './StationRowIcons.vue'
import {
  useStationRowStyle,
  type StationRowCellType,
  type StationCardLayout
} from './useStationRowStyle'

export type CellTypes = StationRowCellType

const STACK_ICONS_MAX = 3
const ROW_ICONS_MAX = 4
// `?? ''`: o withDefaults só cobre `undefined`; um chamador pode mandar `name: null`.

export default /*#__PURE__*/_defineComponent({
  __name: 'withIcon',
  props: {
    tableType: { default: 'EXTRA' },
    name: { default: '' },
    text: { default: '' },
    minimal: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    solid: { type: Boolean, default: false },
    crm: { default: '' },
    success: { type: Boolean, default: true },
    error: { type: Boolean, default: true },
    waiting: { type: Boolean, default: true },
    pendences: { type: Boolean, default: true },
    photo: { default: '' },
    hasObservations: { type: Boolean, default: false },
    doctorPending: { type: Boolean, default: false },
    doctorConfirmed: { type: Boolean, default: false },
    doctorStationStatus: { default: DoctorStationStatus.SEM_STATUS },
    ourTeam: { type: Boolean, default: false },
    doctorStationReminderStatus: { default: DoctorStationReminderStatus.PENDING },
    isAlert: { type: Boolean, default: false },
    requiredCheckNotOurTeam: { type: Boolean },
    requiredCheckOurTeam: { type: Boolean },
    npsScore: { default: null },
    exceptionSummaryStatus: { default: null },
    postStationStatus: { default: null },
    permanenceTooltip: { default: null },
    colorOverride: { default: null },
    mobile: { type: Boolean, default: false },
    cardLayout: { default: 'default' },
    avatarSize: { default: undefined }
  },
  setup(__props: any) {

const props = __props;



const { flags } = useFeatureFlags()

const resolvedPhoto = computed(() => resolveAvatarSrc(props.photo))
/** QA-11: no celular as iniciais saem do nome sem "Dr./Dra." (AS); o desktop segue igual ao main. */
const avatarInitials = computed(() =>
  props.mobile ? nameInitials(stripHonorific(props.name)) : getInitialsChar(props.name)
)

/** Variantes do celular v2: foto maior (decisão 22) e iniciais sem "Dr./Dra." (QA-11 do v1). */
const VARIANT_AVATAR_SIZE: Record<Exclude<StationCardLayout, 'default'>, number> = {
  stack: 32,
  row: 42
}
const layoutAvatarSize = computed(
  () =>
    props.avatarSize ??
    (props.cardLayout === 'default' ? 21 : VARIANT_AVATAR_SIZE[props.cardLayout])
)
const initialsStyle = computed(() => ({
  fontSize: `${Math.max(10, Math.round(layoutAvatarSize.value * 0.38))}px`
}))
/**
 * Espaços de ícone por linha nas variantes (v2.2): acima disso o último vira "+N". Com `max` o
 * gap é de 1 px. Stack: 3 × 16 + 2 × 1 = 50 px, cabe na coluna do iPhone SE (dia de 71 px − 1 de
 * borda − 8 da faixa − 12 de padding = 50 px). Row: 4 × 16 + 3 × 1 = 67 px na coluna de ~77 px.
 */
const variantInitials = computed(() => nameInitials(stripHonorific(props.name ?? '')))
/**
 * v2.2: nome todo em CAIXA ALTA (ex.: "INAE CAVALCANTI MARCONDES MACHADO") ocupa mais largura;
 * nas variantes do celular ele sai em 0,95 do tamanho (11 → 10,45 px; 12 → 11,4 px, nunca < 10 px).
 */
const isUppercaseName = computed(() => {
  const name = props.name ?? ''
  return /\p{L}/u.test(name) && name === name.toUpperCase()
})

// Cor, alerta e ícones vêm do composable (reusado pelo StationListCard do celular).
const {
  stationIsAlert,
  npsRingStyle,
  colorDefination,
  defineOurTeamBgColor,
  isAlertTextColor,
  cardTextClass,
  cardTextStyle,
  notShowStatusIcon,
  exceptionIconPath,
  exceptionIconColor,
  exceptionTooltipText,
  postStationIconColor,
  postStationTooltipText,
  statusIcons
} = useStationRowStyle(() => ({
  tableType: props.tableType,
  solid: props.solid,
  ourTeam: props.ourTeam,
  isAlert: props.isAlert,
  colorOverride: props.colorOverride,
  requiredCheckOurTeam: props.requiredCheckOurTeam,
  requiredCheckNotOurTeam: props.requiredCheckNotOurTeam,
  exceptionSummaryStatus: props.exceptionSummaryStatus,
  postStationStatus: props.postStationStatus,
  npsScore: props.npsScore,
  hasObservations: props.hasObservations,
  doctorPending: props.doctorPending,
  doctorConfirmed: props.doctorConfirmed,
  doctorStationStatus: props.doctorStationStatus,
  permanenceTooltip: props.permanenceTooltip
}))

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_ctx.cardLayout === 'default')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "row-table w-full justify-center h-[72px] md:h-[105px] overflow-hidden",
        style: _normalizeStyle(`background: ${_unref(colorDefination).bg};`)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(`${_unref(colorDefination).stripe} w-2 md:w-3`),
          style: _normalizeStyle(_unref(colorDefination).stripeStyle)
        }, null, 6),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_unref(stationIsAlert))
              ? (_openBlock(), _createBlock(_component_v_avatar, {
                  key: 0,
                  color: "white",
                  size: "21",
                  class: _normalizeClass(["shrink-0", { 'mobile-avatar': !_ctx.mobile }])
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["class"]))
              : (_openBlock(), _createBlock(_component_v_avatar, {
                  key: 1,
                  color: "primary",
                  size: "21",
                  class: _normalizeClass(["shrink-0", { 'mobile-avatar': !_ctx.mobile }]),
                  style: _normalizeStyle(_unref(npsRingStyle))
                }, {
                  default: _withCtx(() => [
                    _createVNode(ProtectedAvatar, {
                      src: resolvedPhoto.value,
                      size: 21
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["font-bold", _ctx.mobile ? 'text-[10px]' : 'text-[.6rem]'])
                        }, _toDisplayString(avatarInitials.value), 3)
                      ]),
                      _: 1
                    }, 8, ["src"])
                  ]),
                  _: 1
                }, 8, ["class", "style"])),
            _createElementVNode("div", _hoisted_4, [
              (!_ctx.ourTeam)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["flex items-center justify-center gap-[10px] rounded-2xl mb-[3px] px-2 py-0 font-sans font-normal not-italic leading-[14px] tracking-[0.06px] text-[var(--Tertiary-40)]", [
              _unref(defineOurTeamBgColor),
              _ctx.mobile
                ? 'h-[18px] w-fit text-[10px]'
                : 'h-[16px] md:h-[21px] w-[40px] md:w-[53px] text-[8px] md:text-[10px]'
            ]])
                  }, "Externo", 2))
                : _createCommentVNode("", true),
              _createVNode(_component_v_tooltip, {
                text: _ctx.name,
                location: "top"
              }, {
                activator: _withCtx(({ props: tooltipProps }) => [
                  _createElementVNode("span", _mergeProps(tooltipProps, {
                    class: ["two-line-ellipsis text-left text-gray-800 leading-tight cursor-default", [
                  _unref(isAlertTextColor),
                  _ctx.mobile ? 'text-[11px]' : 'text-[9px] md:text-[12px] md:max-w-[100px]'
                ]],
                    style: _unref(cardTextStyle)
                  }), _toDisplayString(_ctx.name), 17)
                ]),
                _: 1
              }, 8, ["text"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", {
              class: _normalizeClass(["div3 text-left", [_unref(cardTextClass), _ctx.mobile ? 'text-[10px]' : 'text-[8px] md:text-[10px]']]),
              style: _normalizeStyle(_unref(cardTextStyle))
            }, _toDisplayString(_ctx.crm), 7)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_unref(stationIsAlert))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (_ctx.hasObservations)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          text: "Existe observações"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_icon, _mergeProps({
                              size: "small",
                              color: "warning"
                            }, props, { icon: _unref(mdiTextBoxCheck) }), null, 16, ["icon"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.doctorPending)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 1,
                          text: "Médico pendente"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_icon, _mergeProps({
                              size: "small",
                              color: "primary"
                            }, props, { icon: _unref(mdiAccountAlert) }), null, 16, ["icon"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.doctorConfirmed)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 2,
                          text: "Plantão pendente"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_icon, _mergeProps({
                              size: "small",
                              color: "neutral"
                            }, props, { icon: _unref(mdiClockAlertOutline) }), null, 16, ["icon"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.doctorConfirmed)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 3,
                          text: "Plantão confirmado"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_icon, _mergeProps({
                              size: "small",
                              color: "success"
                            }, props, { icon: _unref(mdiClockCheckOutline) }), null, 16, ["icon"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.doctorStationStatus !== _unref(DoctorStationStatus).SEM_STATUS && !_unref(notShowStatusIcon))
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 4,
                          text: _unref(doctorStationStatusTranslate)[_ctx.doctorStationStatus].text
                        }, {
                          activator: _withCtx(({ props }) => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(doctorStationStatusTranslate)[_ctx.doctorStationStatus].icon), _normalizeProps(_guardReactiveProps(props)), null, 16))
                          ]),
                          _: 1
                        }, 8, ["text"]))
                      : _createCommentVNode("", true),
                    (_ctx.exceptionSummaryStatus)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 5,
                          text: _unref(exceptionTooltipText)
                        }, {
                          activator: _withCtx(({ props: tooltipProps }) => [
                            _createVNode(_component_v_icon, _mergeProps(tooltipProps, {
                              size: "small",
                              icon: _unref(exceptionIconPath),
                              color: _unref(exceptionIconColor)
                            }), null, 16, ["icon", "color"])
                          ]),
                          _: 1
                        }, 8, ["text"]))
                      : _createCommentVNode("", true),
                    (_unref(flags).enabledPostStation && _ctx.postStationStatus)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 6,
                          text: _unref(postStationTooltipText)
                        }, {
                          activator: _withCtx(({ props: tooltipProps }) => [
                            _createVNode(_component_v_icon, _mergeProps(tooltipProps, {
                              "data-testid": "post-station-status-icon",
                              size: "small",
                              icon: _unref(mdiClockEnd),
                              color: _unref(postStationIconColor)
                            }), null, 16, ["icon", "color"])
                          ]),
                          _: 1
                        }, 8, ["text"]))
                      : _createCommentVNode("", true),
                    (_unref(flags).enabledPermanenceRecord && _ctx.permanenceTooltip)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 7,
                          text: _ctx.permanenceTooltip
                        }, {
                          activator: _withCtx(({ props: tooltipProps }) => [
                            _createVNode(PermanenceRecordIcon, _mergeProps(tooltipProps, { "data-testid": "permanence-record-icon" }), null, 16)
                          ]),
                          _: 1
                        }, 8, ["text"]))
                      : _createCommentVNode("", true)
                  ])
                ])),
            _renderSlot(_ctx.$slots, "footer")
          ])
        ])
      ], 4))
    : (_ctx.cardLayout === 'stack')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "flex w-full overflow-hidden",
          style: _normalizeStyle(`background: ${_unref(colorDefination).bg};`),
          "data-testid": "station-row-stack"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(`${_unref(colorDefination).stripe} w-2 shrink-0`),
            style: _normalizeStyle(_unref(colorDefination).stripeStyle)
          }, null, 6),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (_unref(stationIsAlert))
                ? (_openBlock(), _createBlock(_component_v_avatar, {
                    key: 0,
                    color: "white",
                    size: layoutAvatarSize.value,
                    class: "shrink-0"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: "font-bold text-negative",
                        style: _normalizeStyle(initialsStyle.value)
                      }, "!", 4)
                    ]),
                    _: 1
                  }, 8, ["size"]))
                : (_openBlock(), _createBlock(_component_v_avatar, {
                    key: 1,
                    color: "primary",
                    size: layoutAvatarSize.value,
                    class: "shrink-0",
                    style: _normalizeStyle(_unref(npsRingStyle))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ProtectedAvatar, {
                        src: resolvedPhoto.value,
                        size: layoutAvatarSize.value
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: "font-bold",
                            style: _normalizeStyle(initialsStyle.value)
                          }, _toDisplayString(variantInitials.value), 5)
                        ]),
                        _: 1
                      }, 8, ["src", "size"])
                    ]),
                    _: 1
                  }, 8, ["size", "style"])),
              (_unref(stationIsAlert))
                ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                : _createCommentVNode("", true)
            ]),
            (!_unref(stationIsAlert))
              ? (_openBlock(), _createBlock(StationRowIcons, {
                  key: 0,
                  icons: _unref(statusIcons),
                  max: STACK_ICONS_MAX
                }, null, 8, ["icons"]))
              : _createCommentVNode("", true),
            (!_ctx.ourTeam)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["w-fit rounded-2xl px-2 text-[10px] leading-[16px] text-[var(--Tertiary-40)]", _unref(defineOurTeamBgColor)]),
                  "data-testid": "station-row-external"
                }, "Externo", 2))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass(["station-row-name station-row-name--clamp-3 station-row-name--hyphenate text-left leading-tight text-gray-800", [
          _unref(isAlertTextColor),
          isUppercaseName.value ? 'station-row-name--caps text-[10.45px]' : 'text-[11px]'
        ]]),
              style: _normalizeStyle(_unref(cardTextStyle)),
              lang: "pt-BR",
              title: _ctx.name,
              "aria-label": _ctx.name,
              "data-testid": "station-row-name"
            }, _toDisplayString(_ctx.name), 15, _hoisted_14),
            _createElementVNode("p", {
              class: _normalizeClass(["text-left text-[10px] leading-tight", _unref(cardTextClass)]),
              style: _normalizeStyle(_unref(cardTextStyle)),
              "data-testid": "station-row-crm"
            }, _toDisplayString(_ctx.crm), 7),
            _renderSlot(_ctx.$slots, "footer")
          ])
        ], 4))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "flex w-full overflow-hidden",
          style: _normalizeStyle(`background: ${_unref(colorDefination).bg};`),
          "data-testid": "station-row-row"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(`${_unref(colorDefination).stripe} w-2 shrink-0`),
            style: _normalizeStyle(_unref(colorDefination).stripeStyle)
          }, null, 6),
          _createElementVNode("div", _hoisted_15, [
            (_unref(stationIsAlert))
              ? (_openBlock(), _createBlock(_component_v_avatar, {
                  key: 0,
                  color: "white",
                  size: layoutAvatarSize.value,
                  class: "shrink-0"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "font-bold text-negative",
                      style: _normalizeStyle(initialsStyle.value)
                    }, "!", 4)
                  ]),
                  _: 1
                }, 8, ["size"]))
              : (_openBlock(), _createBlock(_component_v_avatar, {
                  key: 1,
                  color: "primary",
                  size: layoutAvatarSize.value,
                  class: "shrink-0",
                  style: _normalizeStyle(_unref(npsRingStyle))
                }, {
                  default: _withCtx(() => [
                    _createVNode(ProtectedAvatar, {
                      src: resolvedPhoto.value,
                      size: layoutAvatarSize.value
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: "font-bold",
                          style: _normalizeStyle(initialsStyle.value)
                        }, _toDisplayString(variantInitials.value), 5)
                      ]),
                      _: 1
                    }, 8, ["src", "size"])
                  ]),
                  _: 1
                }, 8, ["size", "style"])),
            _createElementVNode("div", _hoisted_16, [
              (!_ctx.ourTeam)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["w-fit rounded-2xl px-2 text-[10px] leading-[16px] text-[var(--Tertiary-40)]", _unref(defineOurTeamBgColor)]),
                    "data-testid": "station-row-external"
                  }, "Externo", 2))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: _normalizeClass(["station-row-name station-row-name--clamp-2 text-left leading-tight text-gray-800", [
            _unref(isAlertTextColor),
            isUppercaseName.value ? 'station-row-name--caps text-[11.4px]' : 'text-[12px]'
          ]]),
                style: _normalizeStyle(_unref(cardTextStyle)),
                lang: "pt-BR",
                title: _ctx.name,
                "aria-label": _ctx.name,
                "data-testid": "station-row-name"
              }, _toDisplayString(_ctx.name), 15, _hoisted_17),
              _createElementVNode("p", {
                class: _normalizeClass(["text-left text-[10px] leading-tight", _unref(cardTextClass)]),
                style: _normalizeStyle(_unref(cardTextStyle)),
                "data-testid": "station-row-crm"
              }, _toDisplayString(_ctx.crm), 7),
              (_unref(stationIsAlert))
                ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                : (_openBlock(), _createBlock(StationRowIcons, {
                    key: 2,
                    icons: _unref(statusIcons),
                    max: ROW_ICONS_MAX
                  }, null, 8, ["icons"])),
              _renderSlot(_ctx.$slots, "footer")
            ])
          ])
        ], 4))
}
}

})